<div class="status-badge" [class.status-badge--pulsing]="statusRule.pulsing">
  <split-status [status]="statusRule.badgeStatus" [label]="statusRule.label"></split-status>
</div>
